import { Search as SearchIcon } from '@mui/icons-material';
import { InputAdornment, TextField, useTheme } from '@mui/material';
import type { SearchInputProps } from './ISearchInput';
import { styles } from './styles';

const SearchInput = ({
    value,
    onChange,
    placeholder = 'Quick find',
    width = 200,
    sx,
}: SearchInputProps) => {
    const theme = useTheme();

    return (
        <TextField
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            variant="outlined"
            sx={[styles.root(width), ...(Array.isArray(sx) ? sx : [sx])]}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon sx={styles.icon(theme)} />
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default SearchInput;
